module.exports = __webpack_public_path__ + "img/newsStaff_7-10-2021.c2ac4764.jpg";